import { render, staticRenderFns } from "./chikyMap.vue?vue&type=template&id=0b8e93f5&scoped=true&"
import script from "./chikyMap.vue?vue&type=script&lang=js&"
export * from "./chikyMap.vue?vue&type=script&lang=js&"
import style0 from "./chikyMap.vue?vue&type=style&index=0&id=0b8e93f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8e93f5",
  null
  
)

export default component.exports